import React from 'react'
import DonutCharts from './DonutCharts'
import * as models from '../models/index'
import { Link } from 'react-router-dom'

class StudentDashboard extends React.Component<{ error?: Function }> {
  state = {
    phrases: {
      title: null,
      link: null,
    },
    phonics: {
      title: null,
      link: null,
    },
    stories: {
      title: null,
      link: null,
    },
  }

  private updateProbes: NodeJS.Timeout

  componentDidMount() {
    models.studentProbes.get().then((data) => {
      this.setState(data)
    })

    this.updateProbes = setInterval(() => {
      models.studentProbes.get().then((data) => {
        if (data.valid == false && this.props.error) {
          return this.props.error(data.message)
        }
        this.setState(data)
      })
    }, 2000)
  }

  componentWillUnmount() {
    clearInterval(this.updateProbes)
  }

  /**
   * Generates probe link
   *
   * @param details info about probe
   */
  getLink = (details: { link: string; title: string }) => {
    return (
      <Link
        to={details.link}
        className="list-group-item-action"
        style={details.link == null ? { pointerEvents: 'none' } : null}
      >
        <h4 className="list-group-item-heading pt-2 pb-2 mb-0">
          <strong>
            {details.title ? details.title : 'No exercise selected'}
          </strong>
        </h4>
      </Link>
    )
  }

  render() {
    var { phrases, phonics, stories } = this.state
    return (
      <React.Fragment>
        <DonutCharts />
        <div className="row subheader-text">
          <div className="col-sm-10 offset-sm-1">
            <p>
              Great Leaps exercises selected on the teacher device will appear
              below. When they do please click on them to open each one.
            </p>
          </div>
        </div>

        <div className="row" id="student-probe-list">
          <div className="col-sm-10 offset-sm-1">
            <div className="card">
              <div className="card-header">
                <h4>Phonics</h4>
              </div>

              <div className="card-body list-group">
                {this.getLink(phonics)}
              </div>
            </div>

            <div className="card" style={{ marginTop: '20px' }}>
              <div className="card-header">
                <h4>Sight Phrases</h4>
              </div>

              <div className="card-body list-group">
                {this.getLink(phrases)}
              </div>
            </div>

            <div className="card" style={{ marginTop: '20px' }}>
              <div className="card-header">
                <h4>Stories</h4>
              </div>

              <div className="card-body list-group">
                {this.getLink(stories)}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default StudentDashboard
